import React from 'react';
import { Counter } from './features/counter/Counter';
import './App.css';
function App() {
    return (React.createElement("div", { className: "App" },
        React.createElement("header", { className: "App-header" },
            React.createElement("h1", null, "Redux Toolkits Counter App"),
            React.createElement(Counter, null),
            React.createElement("p", null,
                "Edit ",
                React.createElement("code", null, "src/App.tsx"),
                " and save to reload."),
            React.createElement("span", null,
                React.createElement("span", null, "Learn "),
                React.createElement("a", { className: "App-link", href: "https://reactjs.org/", target: "_blank", rel: "noopener noreferrer" }, "React"),
                React.createElement("span", null, ", "),
                React.createElement("a", { className: "App-link", href: "https://redux.js.org/", target: "_blank", rel: "noopener noreferrer" }, "Redux"),
                React.createElement("span", null, ", "),
                React.createElement("a", { className: "App-link", href: "https://redux-toolkit.js.org/", target: "_blank", rel: "noopener noreferrer" }, "Redux Toolkit"),
                ",",
                React.createElement("span", null, " and "),
                React.createElement("a", { className: "App-link", href: "https://react-redux.js.org/", target: "_blank", rel: "noopener noreferrer" }, "React Redux")))));
}
export default App;
